module.exports = __webpack_public_path__ + "img/welcome-image.6b9bf94e.jpg";